import type { SetupIntentResult } from '@stripe/stripe-js';

export function readPaymentMethodId(result: SetupIntentResult): string | undefined {
    const setupIntent = result.setupIntent;
    if (!setupIntent) return undefined;
    if (typeof setupIntent.payment_method === 'string') return setupIntent.payment_method;
    return setupIntent.payment_method?.id;
}
